import { MiscUtil } from './MiscUtil';
import { TableauMouseButton } from '../../gen-src/preslayer/Enums';
import { TypeUtil } from './TypeUtil';

/**
* Contains utility methods for mouse events
*/
class MouseEventUtil {
  private static areMappingsInstantiated: boolean = false;
  // button mapping for IE 9 - lazily instantiated
  private static mouseButtonMappingsIE: { [buttonId: number]: TableauMouseButton | null } = {};
  // doesn't apply for IE 9 - lazily instantiated
  private static mouseWhichMappings: { [buttonId: number]: TableauMouseButton | null } = {};

  // init mappings
  private static InitMouseButtonMappings(): void {
    if (!MouseEventUtil.areMappingsInstantiated) {
      MouseEventUtil.mouseButtonMappingsIE[1] = TableauMouseButton.Left;
      MouseEventUtil.mouseButtonMappingsIE[4] = TableauMouseButton.Middle;
      MouseEventUtil.mouseButtonMappingsIE[2] = TableauMouseButton.Right;
      MouseEventUtil.mouseWhichMappings[1] = TableauMouseButton.Left;
      MouseEventUtil.mouseWhichMappings[2] = TableauMouseButton.Middle;
      MouseEventUtil.mouseWhichMappings[3] = TableauMouseButton.Right;
      MouseEventUtil.areMappingsInstantiated = true;
    }
  }

  /**
  * Interpret which mouse button was pressed from the raw event object.
  * Browsers have different specs mouse button representations. The basic
  * strategy that's used here is to isolate IE9 from the others.
  *
  * While most browsers support event.button, IE9 values means different
  * from the rest of the browser. Where left, mid, right usually maps to
  * 0, 1, 2, IE maps them to 1, 4, 2.
  *
  * This is where we'll use feature detection to separate IE9. We'll try
  * look for the event.which property which also tells us which button
  * was pressed (the values don't match with event.button though). Since
  * IE9 doesn't support this, we can easily special case event.button
  * only for IE9.
  *
  * Check:
  * http://mytableau/display/DevServFront/Mouse+Events+Madness
  * for related mouse event differences between browsers.
  *
  * @returns Returns MouseButtonEnum
  */
  public static GetMouseButtonEnum(e: TouchEvent): TableauMouseButton {
    // lazy instantiation of mappings
    MouseEventUtil.InitMouseButtonMappings();

    // default output
    let output: TableauMouseButton = TableauMouseButton.None;

    // event.which did not get defined in the metadata, we'll
    // have to extract it manually..
    let whichObj: Object = TypeUtil.GetField<Object>(e, 'which');
    if (!MiscUtil.IsNullOrUndefined(whichObj)) {
      // for chrome, firefox, and safari
      let which: number = whichObj as number;
      if (!MiscUtil.IsNullOrUndefined(MouseEventUtil.mouseWhichMappings[which])) {
        output = MouseEventUtil.mouseWhichMappings[which];
      }
    } else {
      let field = TypeUtil.GetField<number>(e, 'button');
      if (!MiscUtil.IsNullOrUndefined(field)) {
        // for IE9
        let button: number = field;
        if (!MiscUtil.IsNullOrUndefined(MouseEventUtil.mouseButtonMappingsIE[button])) {
          output = MouseEventUtil.mouseButtonMappingsIE[button];
        }
      }
    }
    return output;
  }
}

export { MouseEventUtil };
